<div class="layout-topbar">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <a tabindex="0" class="menu-button" (click)="appMain.onMenuButtonClick($event)">
                <i class="pi pi-bars"></i>
            </a>
            <a tabindex="0" id="logo-link" class="layout-topbar-logo" (click)="appMain.onMenuButtonClick($event)">
            </a>
        </div>

        <app-menu></app-menu>

        <div class="layout-topbar-right">
            <ul class="layout-topbar-actions">
                <li #profile class="topbar-item user-profile"
                    [ngClass]="{'active-topmenuitem fadeInDown': appMain.activeTopbarItem === profile}">
                    <a id="topbar-menu-button" href="#" (click)="appMain.onTopbarItemClick($event,profile)">
                        <i class="pi pi-fw pi-bars" style="font-size: 2rem"></i>
                    </a>
                    <a class="topbar-menu" href="#" (click)="appMain.onTopbarItemClick($event,profile)">
                        <span style="margin-right: 5px; font-size: 13px;" *ngIf="userName"
                            class="profile-text-username">{{userName | titlecase}}</span>
                        <i class="pi pi-fw pi-cog" style="font-size: 2rem"></i>
                    </a>
                    <ul class="fadeInDown">
                        <li (click)="changePassword()">
                            <a>
                                <i class="pi pi-fw pi-lock-open"></i>
                                <span>Cambiar Contraseña</span>
                            </a>
                        </li>
                        <li (click)="changeGame()">
                            <a>
                                <i class="pi pi-fw pi-moon"></i>
                                <span>Cambiar Juego</span>
                            </a>
                        </li>
                        <li (click)="signOut()">
                            <a>
                                <i class="pi pi-fw pi-sign-out"></i>
                                <span>{{'LOGOUT.lbLogOut'|translate}}</span>
                            </a>
                        </li>

                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>
